// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InteractiveWindow_interactiveWindow__\\+PFWQ {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 600px;  /* Set your desired fixed height here */
  width: 90%;
  border: 1px solid #888;
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
  background-color: #484848;
  overflow: hidden;  /* Ensure that overflowing content doesn't spill outside */
  position: relative;
}

.InteractiveWindow_interactiveWindow__\\+PFWQ .InteractiveWindow_interactiveWindowContent__Td360 p {
  color: white;
}

.InteractiveWindow_interactiveWindowContent__Td360 {
  margin-top: 20px;  /* Add some top margin */
  height: 500px;
  border: 2px solid #888;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #2a6dff86;
  overflow-y: auto;
  color: white;  /* Change the text color here */
  font-size: 18px;
}

.InteractiveWindow_inputForm__p7wrP {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.InteractiveWindow_inputFormInput__UDAns {
  width: 75%;
  padding: 10px;     /* Increase padding for a larger text box */
  border-radius: 5px;
  font-size: 16px;   /* Increase font size */
}
.InteractiveWindow_inputFormButton__GPXFR {
  width: 30%;
  padding: 5px;
  border-radius: 5px;
  background-color: #e90e7c;
  color: white;
  border: none;
}

.InteractiveWindow_typingIndicator__xcKau {
  color: #ffffff;
  font-style: italic;
}

.InteractiveWindow_loadingContainer__KO-yl {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}

.InteractiveWindow_closeButton__AbeUj {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px 20px;  /* Increase padding for a bigger button */
  font-size: 16px;  /* Adjust as per design preference */
}
`, "",{"version":3,"sources":["webpack://./src/components/InteractiveWindow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa,GAAG,uCAAuC;EACvD,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB,GAAG,0DAA0D;EAC7E,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB,GAAG,wBAAwB;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY,GAAG,+BAA+B;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa,MAAM,2CAA2C;EAC9D,kBAAkB;EAClB,eAAe,IAAI,uBAAuB;AAC5C;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB,GAAG,yCAAyC;EAC9D,eAAe,GAAG,oCAAoC;AACxD","sourcesContent":[".interactiveWindow {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 600px;  /* Set your desired fixed height here */\n  width: 90%;\n  border: 1px solid #888;\n  border-radius: 10px;\n  padding: 10px;\n  font-size: 12px;\n  background-color: #484848;\n  overflow: hidden;  /* Ensure that overflowing content doesn't spill outside */\n  position: relative;\n}\n\n.interactiveWindow .interactiveWindowContent p {\n  color: white;\n}\n\n.interactiveWindowContent {\n  margin-top: 20px;  /* Add some top margin */\n  height: 500px;\n  border: 2px solid #888;\n  border-radius: 10px;\n  padding: 10px;\n  margin-bottom: 10px;\n  background-color: #2a6dff86;\n  overflow-y: auto;\n  color: white;  /* Change the text color here */\n  font-size: 18px;\n}\n\n.inputForm {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.inputFormInput {\n  width: 75%;\n  padding: 10px;     /* Increase padding for a larger text box */\n  border-radius: 5px;\n  font-size: 16px;   /* Increase font size */\n}\n.inputFormButton {\n  width: 30%;\n  padding: 5px;\n  border-radius: 5px;\n  background-color: #e90e7c;\n  color: white;\n  border: none;\n}\n\n.typingIndicator {\n  color: #ffffff;\n  font-style: italic;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 10px 20px;  /* Increase padding for a bigger button */\n  font-size: 16px;  /* Adjust as per design preference */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"interactiveWindow": `InteractiveWindow_interactiveWindow__+PFWQ`,
	"interactiveWindowContent": `InteractiveWindow_interactiveWindowContent__Td360`,
	"inputForm": `InteractiveWindow_inputForm__p7wrP`,
	"inputFormInput": `InteractiveWindow_inputFormInput__UDAns`,
	"inputFormButton": `InteractiveWindow_inputFormButton__GPXFR`,
	"typingIndicator": `InteractiveWindow_typingIndicator__xcKau`,
	"loadingContainer": `InteractiveWindow_loadingContainer__KO-yl`,
	"closeButton": `InteractiveWindow_closeButton__AbeUj`
};
export default ___CSS_LOADER_EXPORT___;
